import React, { useEffect, useState } from 'react'
import DepthDistributionDiagram from './DepthDistributionDiagram'

// const geneData = {
//   genes: [
//     {
//       name: 'EGFR',
//       meanDepth: 987.4,
//       minDepth: 201,
//       maxDepth: 1532,
//       percentCovered100x: 98.7,
//     },
//     {
//       name: 'KRAS',
//       meanDepth: 876.2,
//       minDepth: 312,
//       maxDepth: 1205,
//       percentCovered100x: 99.1,
//     },
//     {
//       name: 'TP53',
//       meanDepth: 754.9,
//       minDepth: 198,
//       maxDepth: 1102,
//       percentCovered100x: 97.5,
//     },
//     {
//       name: 'ALK',
//       meanDepth: 689.3,
//       minDepth: 156,
//       maxDepth: 1087,
//       percentCovered100x: 96.8,
//     },
//     {
//       name: 'MET',
//       ensemblId: 'ENSG00000105976',
//       chromosome: '7',
//       meanDepth: 621.7,
//       minDepth: 145,
//       maxDepth: 952,
//       percentCovered20x: 100.0,
//       variantCount: 1,
//       pathways: ['RTK/RAS/RAF', 'PI3K/AKT'],
//     },
//     {
//       name: 'BRAF',
//       ensemblId: 'ENSG00000157764',
//       chromosome: '7',
//       meanDepth: 587.6,
//       minDepth: 132,
//       maxDepth: 901,
//       percentCovered20x: 100.0,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF', 'MAPK'],
//     },
//     {
//       name: 'PIK3CA',
//       ensemblId: 'ENSG00000121879',
//       chromosome: '3',
//       meanDepth: 543.8,
//       minDepth: 124,
//       maxDepth: 872,
//       percentCovered20x: 100.0,
//       variantCount: 1,
//       pathways: ['PI3K/AKT'],
//     },
//     {
//       name: 'RET',
//       ensemblId: 'ENSG00000165731',
//       chromosome: '10',
//       meanDepth: 498.2,
//       minDepth: 110,
//       maxDepth: 821,
//       percentCovered20x: 100.0,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF'],
//     },
//     {
//       name: 'ROS1',
//       ensemblId: 'ENSG00000047936',
//       chromosome: '6',
//       meanDepth: 465.3,
//       minDepth: 102,
//       maxDepth: 792,
//       percentCovered20x: 99.8,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF'],
//     },
//     {
//       name: 'PTEN',
//       ensemblId: 'ENSG00000171862',
//       chromosome: '10',
//       meanDepth: 423.9,
//       minDepth: 89,
//       maxDepth: 743,
//       percentCovered20x: 99.7,
//       variantCount: 1,
//       pathways: ['PI3K/AKT'],
//     },
//     {
//       name: 'ERBB2',
//       ensemblId: 'ENSG00000141736',
//       chromosome: '17',
//       meanDepth: 402.6,
//       minDepth: 95,
//       maxDepth: 712,
//       percentCovered20x: 100.0,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF', 'PI3K/AKT'],
//     },
//     {
//       name: 'STK11',
//       ensemblId: 'ENSG00000118046',
//       chromosome: '19',
//       meanDepth: 387.1,
//       minDepth: 78,
//       maxDepth: 698,
//       percentCovered20x: 99.5,
//       variantCount: 1,
//       pathways: ['mTOR', 'AMPK'],
//     },
//     {
//       name: 'CDKN2A',
//       ensemblId: 'ENSG00000147889',
//       chromosome: '9',
//       meanDepth: 354.8,
//       minDepth: 67,
//       maxDepth: 643,
//       percentCovered20x: 98.9,
//       variantCount: 2,
//       pathways: ['Cell Cycle'],
//     },
//     {
//       name: 'NTRK1',
//       ensemblId: 'ENSG00000198400',
//       chromosome: '1',
//       meanDepth: 321.7,
//       minDepth: 59,
//       maxDepth: 602,
//       percentCovered20x: 98.3,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF'],
//     },
//     {
//       name: 'MDM2',
//       ensemblId: 'ENSG00000135679',
//       chromosome: '12',
//       meanDepth: 298.4,
//       minDepth: 54,
//       maxDepth: 587,
//       percentCovered20x: 97.8,
//       variantCount: 0,
//       pathways: ['Cell Cycle', 'p53'],
//     },
//     {
//       name: 'AKT1',
//       ensemblId: 'ENSG00000142208',
//       chromosome: '14',
//       meanDepth: 276.3,
//       minDepth: 48,
//       maxDepth: 543,
//       percentCovered20x: 97.1,
//       variantCount: 0,
//       pathways: ['PI3K/AKT'],
//     },
//     {
//       name: 'KEAP1',
//       ensemblId: 'ENSG00000079999',
//       chromosome: '19',
//       meanDepth: 254.9,
//       minDepth: 43,
//       maxDepth: 521,
//       percentCovered20x: 96.5,
//       variantCount: 1,
//       pathways: ['NRF2', 'Oxidative Stress'],
//     },
//     {
//       name: 'NF1',
//       ensemblId: 'ENSG00000196712',
//       chromosome: '17',
//       meanDepth: 236.2,
//       minDepth: 39,
//       maxDepth: 498,
//       percentCovered20x: 95.8,
//       variantCount: 1,
//       pathways: ['RTK/RAS/RAF'],
//     },
//     {
//       name: 'RB1',
//       ensemblId: 'ENSG00000139687',
//       chromosome: '13',
//       meanDepth: 211.7,
//       minDepth: 36,
//       maxDepth: 475,
//       percentCovered20x: 95.3,
//       variantCount: 0,
//       pathways: ['Cell Cycle'],
//     },
//     {
//       name: 'NRAS',
//       ensemblId: 'ENSG00000213281',
//       chromosome: '1',
//       meanDepth: 198.4,
//       minDepth: 31,
//       maxDepth: 432,
//       percentCovered20x: 94.7,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF'],
//     },
//     {
//       name: 'SMARCA4',
//       ensemblId: 'ENSG00000127616',
//       chromosome: '19',
//       meanDepth: 187.2,
//       minDepth: 29,
//       maxDepth: 412,
//       percentCovered20x: 93.9,
//       variantCount: 1,
//       pathways: ['Chromatin Remodeling'],
//     },
//     {
//       name: 'FGFR1',
//       ensemblId: 'ENSG00000077782',
//       chromosome: '8',
//       meanDepth: 165.9,
//       minDepth: 25,
//       maxDepth: 387,
//       percentCovered20x: 92.6,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF'],
//     },
//     {
//       name: 'ERBB4',
//       ensemblId: 'ENSG00000178568',
//       chromosome: '2',
//       meanDepth: 148.3,
//       minDepth: 21,
//       maxDepth: 356,
//       percentCovered20x: 91.2,
//       variantCount: 0,
//       pathways: ['RTK/RAS/RAF'],
//     },
//     {
//       name: 'ATM',
//       ensemblId: 'ENSG00000149311',
//       chromosome: '11',
//       meanDepth: 134.8,
//       minDepth: 18,
//       maxDepth: 321,
//       percentCovered20x: 89.5,
//       variantCount: 1,
//       pathways: ['DNA Repair'],
//     },
//     {
//       name: 'BRCA1',
//       ensemblId: 'ENSG00000012048',
//       chromosome: '17',
//       meanDepth: 119.2,
//       minDepth: 14,
//       maxDepth: 287,
//       percentCovered20x: 87.8,
//       variantCount: 0,
//       pathways: ['DNA Repair', 'Homologous Recombination'],
//     },
//     {
//       name: 'BRCA2',
//       ensemblId: 'ENSG00000139618',
//       chromosome: '13',
//       meanDepth: 102.6,
//       minDepth: 11,
//       maxDepth: 254,
//       percentCovered20x: 84.3,
//       variantCount: 0,
//       pathways: ['DNA Repair', 'Homologous Recombination'],
//     },
//     {
//       name: 'MLH1',
//       ensemblId: 'ENSG00000076242',
//       chromosome: '3',
//       meanDepth: 87.4,
//       minDepth: 9,
//       maxDepth: 216,
//       percentCovered20x: 82.1,
//       variantCount: 0,
//       pathways: ['DNA Repair', 'Mismatch Repair'],
//     },
//     {
//       name: 'MSH2',
//       ensemblId: 'ENSG00000095002',
//       chromosome: '2',
//       meanDepth: 74.8,
//       minDepth: 7,
//       maxDepth: 192,
//       percentCovered20x: 78.6,
//       variantCount: 0,
//       pathways: ['DNA Repair', 'Mismatch Repair'],
//     },
//     {
//       name: 'MSH6',
//       ensemblId: 'ENSG00000116062',
//       chromosome: '2',
//       meanDepth: 62.1,
//       minDepth: 5,
//       maxDepth: 167,
//       percentCovered20x: 74.2,
//       variantCount: 0,
//       pathways: ['DNA Repair', 'Mismatch Repair'],
//     },
//     {
//       name: 'PMS2',
//       ensemblId: 'ENSG00000122512',
//       chromosome: '7',
//       meanDepth: 53.6,
//       minDepth: 4,
//       maxDepth: 143,
//       percentCovered20x: 69.8,
//       variantCount: 0,
//       pathways: ['DNA Repair', 'Mismatch Repair'],
//     },
//   ],
// }

const GeneCoverageSummary = ({ setShowGeneCoverageSummaryModal, coverageData, totalVariants,
  filteredTotalVariants,lowConfidenceVariants }) => {
  const [stats, setStats] = useState({})

  useEffect(() => {
    const genes = coverageData.genes
    const totalGenes = genes.length
    const avgMeanDepth = genes.reduce((sum, g) => sum + g.meanDepth, 0) / totalGenes
    const avgMinDepth = genes.reduce((sum, g) => sum + g.minDepth, 0) / totalGenes
    const avgMaxDepth = genes.reduce((sum, g) => sum + g.maxDepth, 0) / totalGenes
    const avgCoverage100x = genes.reduce((sum, g) => sum + g.percentCovered100x, 0) / totalGenes
    const highCoverageGenes = genes.filter((g) => g.percentCovered100x >= 90)

    const depthCategories = {
      high: genes.filter((g) => g.meanDepth > 500).length,
      med: genes.filter((g) => g.meanDepth <= 500 && g.meanDepth >= 100).length,
      low: genes.filter((g) => g.meanDepth < 100).length,
    }

    const highest = genes.reduce((prev, curr) =>
      prev.percentCovered100x > curr.percentCovered100x ? prev : curr
    )
    const lowest = genes.reduce((prev, curr) =>
      prev.percentCovered100x < curr.percentCovered100x ? prev : curr
    )

    setStats({
      totalGenes,
      avgMeanDepth,
      avgMinDepth,
      avgMaxDepth,
      avgCoverage100x,
      highCoverageGenesCount: highCoverageGenes.length,
      highCoveragePercent: (highCoverageGenes.length / totalGenes) * 100,
      depthCategories,
      highest,
      lowest,
    })
  }, [])

  return (
    <div className=' w-100'>
      {/* Key Metrics */}

      {/* Depth Distribution and Coverage */}
      <div className='row '>
        <div className='col-md-12 mb-4 mb-md-0'>
          <div className='card  bg-light  border-gray-300 '>
            {/* <div className='card-header bg-success text-white'>
              <h5 className='mb-0'>Depth Distribution</h5>
            </div> */}
            {/* <div
              className='card-header p-3 py-0 '
              style={{
                minHeight: 'auto',
              }}
            >
              <h5 className='py-3 mb-0'>Genes Coverage Summary</h5>
            </div> */}
            <div className='card-body p-3'>
              <div
                className='row flex-wrap px-3'
                style={{
                  height: 'auto',
                }}
              >
                <DepthBox title='Total Genes' value={stats.totalGenes} icon='arrow-right-circle' col={6} />
                <DepthBox
                  title='Avg  Depth'
                  value={`${stats.avgMeanDepth?.toFixed(1)}x`}
                  //   icon='arrow-up-circle'
                  col={6} />
       

                {/* <DepthBox
                  title='Avg 100x '
                  value={`${stats.avgCoverage100x?.toFixed(1)}%`}
                //   icon='arrow-up-circle'
                />
                <DepthBox
                  title='≥90% at_100x'
                  //   icon='arrow-up-circle'
                  value={`${stats.highCoverageGenesCount}`}
                /> */}
              </div>
              <div className='d-flex align-items-center gap-5'>
                <DepthDistributionDiagram coverageData={coverageData.genes} setShowGeneCoverageSummaryModal={setShowGeneCoverageSummaryModal} />
                {/* <div className='w-100'> 
                  <div className='progress mb-3 mt-3 ' style={{ height: 40 }}>
                    <div
                      className='progress-bar bg-danger '
                      style={{ width: `${(stats.depthCategories?.high / stats.totalGenes) * 100}%` }}
                    >
                      {stats.depthCategories?.high}
                    </div>
                    <div
                      className='progress-bar bg-warning'
                      style={{ width: `${(stats.depthCategories?.med / stats.totalGenes) * 100}%` }}
                    >
                      {stats.depthCategories?.med}
                    </div>
                    <div
                      className='progress-bar bg-info'
                      style={{ width: `${(stats.depthCategories?.low / stats.totalGenes) * 100}%` }}
                    >
                      {stats.depthCategories?.low}
                    </div>
                  </div>
                  <div className='d-flex justify-content-between fs-9'>
                    <small>Low (&lt;100x)</small>
                    <small>Medium (100-500x)</small>
                    <small>High (&gt;500x)</small>
                  </div>
                </div> */}
                {/* <button
                  type='button'
                  className='btn btn-primary btn-sm  py-2 fs-9 ms-auto'
                  onClick={() => {
                    setShowGeneCoverageSummaryModal(true)
                  }}
                >
                  By Genes
                </button> */}
              </div>
            </div>
          </div>
        </div>

        {/* <div className='col-md-6'>
          <div className='card shadow-sm h-100'>
            <div className='card-header bg-info text-white'>
              <h5 className='mb-0'>Coverage Metrics</h5>
            </div>
            <div className='card-body'>
              <div className='row g-3'>
                <CoverageBox
                  title='Highest Coverage'
                  gene={stats.highest?.name}
                  percent={`${stats.highest?.percentCovered100x}%`}
                  badgeClass='bg-success'
                />
                <CoverageBox
                  title='Lowest Coverage'
                  gene={stats.lowest?.name}
                  percent={`${stats.lowest?.percentCovered100x}%`}
                  badgeClass='bg-warning'
                />
                <DepthBox
                  title='Mean Min Depth'
                  icon='arrow-down-circle'
                  value={`${stats.avgMinDepth?.toFixed(1)}x`}
                  iconColor='text-warning'
                />
                <DepthBox
                  title='Mean Max Depth'
                  icon='arrow-up-circle'
                  value={`${stats.avgMaxDepth?.toFixed(1)}x`}
                  iconColor='text-primary'
                />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

const Metric = ({ title, value }) => (
  <div className='col'>
    <div className='card h-100 border-0 bg-light'>
      <div className='card-body text-center'>
        <h6 className='text-muted mb-2'>{title}</h6>
        <h2 className='mb-0'>{value}</h2>
      </div>
    </div>
  </div>
)

const CoverageBox = ({ title, gene, percent, badgeClass }) => (
  <div className='col-6 mt-2'>
    <div className='border rounded p-3 '>
      <h6>{title}</h6>
      <div className='d-flex justify-content-between align-items-center mt-3'>
        <span className={`badge ${badgeClass} fs-6`}>{gene}</span>
        <strong>{percent}</strong>
      </div>
    </div>
  </div>
)

const DepthBox = ({ title, icon, value, iconColor,col }) => (
  <div className={`col-${col} mt-2  px-1`}>
    <div className='border rounded h-100  py-2 px-3 d-flex gap-4 align-items-center '>
      <div className='d-flex fs-7 justify-content-between align-items-center '>
        <strong>{value}</strong>
      </div>
      <h6
        className='fs-8 mb-0  '
        style={{
          width: 'min-content',
        }}
      >
        {title}
      </h6>
    </div>
  </div>
)

export default GeneCoverageSummary
